import { Dataset } from '../../../../../../types/types';

// True when the reference's label column (labelItem, or idItem fallback) is a
// dateTime element in the dataset definition. Such references get special
// display handling: the raw value is formatted, and the quicksearch/autocomplete
// is disabled (server can't match a formatted date against raw stored values).
export const isDateTimeReferenceColumn = (
  dataset: Dataset | undefined,
  labelItem: string
): boolean => {
  const column = Array.isArray(dataset?.items)
    ? dataset?.items.find((item) => item?.name === labelItem)
    : undefined;

  return column?.type === 'dateTime';
};
